import { Group, Vector3, Geometry, Line, WireframeGeometry, LineBasicMaterial, Color, BufferGeometry, BufferAttribute, SphereGeometry, LineSegments } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Bomb extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(255, 200, 100)"),
	          linewidth: 4,
            transparent: true,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        // Init state
        this.state = {
            pstate: parent.state,
            size: 100.0,
            set: this.set.bind(this),
            mat: material,
        };

        const geometry = new SphereGeometry( 10, 15, 10);
        const wireframe = new WireframeGeometry( geometry );
        const line = new LineSegments( wireframe );
        line.material = material;
        this.add(line);

        this.name = "bomb";
        this.visible = false;
        this.position.y += 1.5;
        // Add self to parent's update list
        parent.addToUpdateList(this);
    }

    set(){
        this.visible = true;
        this.state.size = 1.0;
        this.scale.x = .1;
        this.scale.y = .1;
        this.scale.z = .1;
        this.state.mat.opacity = 1;
        this.position.copy(this.state.pstate.playerPos);
    }

    update(timeStamp) {
        if (this.state.size > 100){
            this.visible = false;
        } else {
            this.state.size += 0.3;
            this.scale.x += 0.03;
            this.scale.y += 0.03;
            this.scale.z += 0.03;
            this.state.mat.opacity -= 0.005;
            const c = this.state.pstate.colliders;
            var kill = false;
            for (var i = 0; i<c.length; i++){
                if (c[i].name != "floor" && this.position.distanceTo(c[i].position) < this.state.size){
                    c[i].state.hp = 0;
                    this.state.pstate.target = c[i];
                    kill = true;
                }
            }
            if (kill){
                this.state.pstate.kill();
            }
        }
    }
}


export default Bomb;
